import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';

const ConfirmationModalImport = ({ showModal, onCloseFunction, onConfirmFunction, video }) => {
  return (
    <Modal show={showModal} onHide={onCloseFunction}>
      <Modal.Header closeButton>
        <Modal.Title>
          Select if annotations will be synchronized by their associated time or position.
        </Modal.Title>
      </Modal.Header>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => onConfirmFunction(true, false)}>
          Import by position
        </Button>
        <Button variant="secondary" onClick={() => onConfirmFunction(false, false)}>
          Import by time
        </Button>
        {video.type !== 'point' && (
          <Button variant="secondary" onClick={() => onConfirmFunction(false, true)}>
            Import by GPS time
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

ConfirmationModalImport.defaultProps = {
  video: {}
};

ConfirmationModalImport.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onCloseFunction: PropTypes.func.isRequired,
  onConfirmFunction: PropTypes.func.isRequired,
  video: PropTypes.object
};

export default ConfirmationModalImport;
